import { useEffect, useState } from "react";
import { LuRouteOff, LuUsers } from "react-icons/lu";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import SyncButton from "../../../components/SyncButton/SyncButton";
import { useListManager } from "../../../contexts/list.manager";
import { useUserStore } from "../../../contexts/userStore";
import FormInterlocks from "../FormInterlocks/FormInterlocks";
import ListInterlocks from "../ListInterlocks/ListInterlocks";
import "./ConsultaInterlocks.css";
import { TbCornerUpRightDouble } from "react-icons/tb";

const ConsultaInterlocks = () => {
	const { lineSelected } = useListManager();
	const [search, setSearch] = useState("");
	const [filters, setFilters] = useState("");
	const { selectedCondominio } = useUserStore();
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<LuRouteOff size={20} />}
					title="Intertravamentos"
					navigate="../cadastro-interlocks"
					buttonLabel="Adicionar Intertravamento"
					aditionalButton1={
						<SyncButton
							type={"interlock"}
							selectedCondominio={selectedCondominio}
						/>
					}
				>
					<SearchInput
						value={search}
						placeholder="Buscar Intertravamento"
						onChange={({ target }) => setSearch(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(search)}
					/>
				</SearchContainer>
				<Container>
					<ListInterlocks filters={filters} refreshKey={refreshKey} />
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormInterlocks interlock={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaInterlocks;
